<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to="/moderate/section/new"><i class="fa fa-plus"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">
		<div class="card">
			<div class="card-block row">
				<table class="table table-striped table-no-bordered table-hover table-responsive" cellspacing="0" style="width: 100%;">
					<thead>
							<tr>
								<th class="sorting_asc" tabindex="0">Име</th>
								<th class="sorting" tabindex="0">Описание</th>
							</tr>
					</thead>
					<tbody>
						<tr v-for="section in items" role="row">
							<td>
								<span class="cat-badge" :style="'background-color:' + (section.color || 'black')"></span>
								<i v-if="section.paid" class="fa fa-lock"></i>
								<router-link :to="'/moderate/section/' + section.id + '/edit'">{{section.name}}</router-link>
							</td>
							<td>{{ section.description }}</td>
						</tr>

					</tbody>
				</table>
			</div>
		</div>
		<!-- end of card -->
	</div>
</div>
</template>

<script>
module.exports = {
	data: function() {
		return {
			items: [],
			total: 0,
			dataReady: false
		};
	},
	created: function() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function() {
			this.$http.get('backend://section').then((response) => {
				this.items = response.body.items;
				this.total = response.body.total;
				this.pages = Math.ceil(this.total / this.rpp);
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},

		remove: function(id) {
			this.$http.delete('backend://section/' + id).then((result) => {
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		}
	}
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// SectionList.vue?738c5b7f